<template>
  <div class="pdf-viewer">
    <div class="pdf-viewer__content">
      <div class="text-right" style="padding-right: 50px;: ">
        <v-btn icon @click="rotate">
          <svg
            width="25"
            height="25"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512.002 512.002"
            xml:space="preserve"
          >
            <path
              d="M459.649,278.626L233.377,52.354c-12.512-12.48-32.736-12.48-45.248,0L52.353,188.13c-12.48,12.48-12.48,32.768,0,45.248
			L278.625,459.65c6.24,6.24,14.432,9.344,22.624,9.344c8.192,0,16.384-3.136,22.624-9.344l135.776-135.776
			C472.129,311.394,472.129,291.106,459.649,278.626z M74.977,210.754L210.753,74.978l22.624,22.624L97.601,233.378L74.977,210.754z
			 M256.001,391.778L120.225,256.002l135.776-135.776l135.776,135.776L256.001,391.778z M301.249,437.026l-22.624-22.624
			l135.776-135.776l22.624,22.624L301.249,437.026z"
            />

            <path
              d="M159.681,488.034c-0.064-0.384,0.064-0.768,0-1.184l-16-74.24c-1.888-8.64-10.464-14.144-19.04-12.256
			c-8.64,1.856-14.112,10.368-12.288,19.008l8.32,38.624C65.377,419.65,32.001,357.282,32.001,288.002c0-8.832-7.168-16-16-16
			c-8.832,0-16,7.168-16,16c0,76.032,35.008,144.576,93.248,189.248l-46.208,2.784c-8.8,0.544-15.52,8.096-15.008,16.928
			c0.512,8.48,7.552,15.04,15.968,15.04c0.32,0,0.64,0,0.96-0.032l96-5.76c0.16,0,0.288-0.096,0.48-0.128
			c0.64-0.064,1.312-0.064,1.952-0.192c0.672-0.16,1.184-0.576,1.824-0.8c0.928-0.32,1.856-0.608,2.688-1.088
			c0.288-0.16,0.544-0.256,0.832-0.448c0.672-0.448,1.184-1.024,1.792-1.568c0.768-0.704,1.472-1.376,2.112-2.208
			c0.512-0.672,0.96-1.376,1.344-2.144c0.128-0.256,0.416-0.32,0.512-0.576c0.128-0.256,0.096-0.512,0.192-0.768
			c0.256-0.608,0.416-1.248,0.608-1.888c0.224-0.8,0.352-1.568,0.448-2.368c0.032-0.672,0.128-1.312,0.128-1.984
			c0-0.256,0.128-0.48,0.096-0.768C159.937,488.834,159.713,488.482,159.681,488.034z"
            />

            <path
              d="M418.753,34.754l46.208-2.784c8.8-0.544,15.52-8.096,15.008-16.928c-0.512-8.8-7.136-15.584-16.928-15.008l-96,5.76
			c-0.416,0.032-0.768,0.256-1.184,0.32c-0.416,0.064-0.8-0.064-1.216,0c-0.352,0.064-0.608,0.32-0.96,0.416
			c-0.64,0.192-1.248,0.384-1.856,0.64c-0.672,0.288-1.28,0.64-1.92,1.024c-0.608,0.352-1.184,0.704-1.76,1.152
			c-0.48,0.384-0.928,0.768-1.376,1.216c-0.512,0.512-0.928,1.056-1.376,1.632c-0.48,0.608-0.864,1.216-1.248,1.888
			c-0.16,0.32-0.48,0.512-0.608,0.832c-0.128,0.256-0.096,0.512-0.192,0.768c-0.256,0.608-0.416,1.248-0.608,1.888
			c-0.224,0.8-0.352,1.568-0.448,2.4c-0.064,0.672-0.16,1.312-0.16,1.984c0,0.256-0.128,0.512-0.096,0.768
			c0.032,0.416,0.256,0.768,0.288,1.152c0.064,0.416-0.064,0.832,0,1.248l16,74.24c1.664,7.52,8.288,12.64,15.648,12.64
			c1.12,0,2.272-0.096,3.392-0.352c8.64-1.856,14.112-10.368,12.288-19.008l-8.32-38.656
			c55.296,38.368,88.672,100.736,88.672,170.016c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16
			C512.001,147.97,476.993,79.426,418.753,34.754z"
            />
          </svg>
        </v-btn>
      </div>

      <div
        class="pdf-viewer__drop"
        :class="{ 'pdf-viewer__drop-start-dragging': startDraggingFile }"
        @dragenter="onDragEnter"
        @dragover="onDragOver"
        @dragleave="onDragLeave"
        @drop.prevent="onDrop"
        :style="{
          'max-height': `${contentHeight}px`,
        }"
      >
        <div
          style="width: 100%; height: 100%"
          v-if="item"
          v-for="item in imageData"
          :key="item.id"
        >
          <embed
            style="width: 100%; height: 100%"
            :src="`${RESOURCE_URL}/api/file/view-image/${item.file}#toolbar=0&navpanes=0&scrollbar=0`"
          />
        </div>
        <div v-else class="d-block">
          <div
            class="d-flex flex-column pdf-viewer__drop__uploader"
            v-if="!pdf.images.length"
          >
            <!--            <div-->
            <!--              class="pdf-viewer__drop__uploader__block mx-auto d-flex align-center justify-center mb-6"-->
            <!--            >-->
            <!--              <v-icon-->
            <!--                size="80"-->
            <!--                class="mb-6 pdf-viewer__drop__uploader__block__icon mx-auto d-block mt-4"-->
            <!--                color="#757575"-->
            <!--              >-->
            <!--                mdi-upload-->
            <!--              </v-icon>-->
            <!--            </div>-->

            <span class="pdf-viewer__drop__label">{{ $t("viewFile") }}</span>
          </div>
          <!--          <v-btn-->
          <!--            v-if="!pdf.images.length && withBtn === true"-->
          <!--            @click="-->
          <!--              () => {-->
          <!--                if (!loading) {-->
          <!--                  $refs.fileInput.click();-->
          <!--                }-->
          <!--              }-->
          <!--            "-->
          <!--            class="d-block mx-auto mt-8"-->
          <!--            id="upload-file-button"-->
          <!--            tile-->
          <!--            color="primary"-->
          <!--            dark-->
          <!--          >-->
          <!--            {{ $t("uploadFile") }}-->
          <!--          </v-btn>-->
        </div>
        <div
          v-if="pdf.images.length"
          class="pdf-viewer__drop__reader"
          :style="{
            'max-height': `${contentHeight}px`,
          }"
        >
          <div
            class="navigation"
            :style="[pdf.images.length > 0 ? '' : { display: 'none' }]"
          >
            <button
              class="hooper-prev"
              :class="[isPrevDisabled ? 'is-disabled' : '']"
              @click="prevPage"
            >
              <svg
                class="icon icon-arrowLeft"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
              >
                <title>Arrow Left</title>
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                ></path>
              </svg>
            </button>
            <button
              type="button"
              class="hooper-next"
              :class="[isNextDisabled ? 'is-disabled' : '']"
              @click="nextPage"
            >
              <svg
                class="icon icon-arrowRight"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
              >
                <title>Arrow Right</title>
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                ></path>
              </svg>
            </button>
          </div>
          <div class="pdf-viewer__slide__box-1__form">
            <div class="pdf-viewer__slide__box-1__inner">
              <div class="d-flex align-center">
                <v-form
                  v-if="pdf.images.length > 1"
                  @submit.prevent="handleSlide"
                  style="position: relative; padding-right: 10px"
                >
                  <custom-input-text
                    @keypress.enter="handleSlide"
                    :placeholder="$t('pageCount')"
                    style="min-width: 160px"
                    class="user_input no-margin"
                    v-model="carouselPage"
                    only="number"
                  >
                  </custom-input-text>
                  <v-icon
                    @click="handleSlide"
                    style="
                      position: absolute;
                      top: 8px;
                      right: 15px;
                      cursor: pointer;
                    "
                  >
                    mdi-arrow-right-thick
                  </v-icon>
                </v-form>
                <span
                  style="font-weight: 600"
                  v-if="pdf.images.length > 1 && $refs.carousel"
                  >{{ $refs.carousel.currentSlide + 1 }}/{{
                    pdf.images.length
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="pdf-viewer__slide__box pdf-viewer__slide__box-1">
            <CoolLightBox
              :items="pdf.images"
              :index="coolBoxIndex"
              @close="coolBoxIndex = null"
            >
            </CoolLightBox>
            <div class="pdf-viewer__slide__box-1__hooper">
              <hooper
                :wheelControl="false"
                ref="carousel"
                group="slider"
                @slide="getCurrentSlidePage"
              >
                <slide v-for="(img, i) in pdf.images" :key="i" :index="i">
                  <img
                    :style="{ transform: rotationPdfViewer }"
                    @click="coolBoxIndex = i"
                    :src="img"
                    alt="..."
                  />
                  <div :style="{ backgroundImage: 'url(' + img + ')' }"></div>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
          </div>

          <!--          <div class="pdf-viewer__slide__box pdf-viewer__slide__box-2">-->
          <!--            <hooper group="slider" :itemsToShow="3">-->
          <!--              <slide v-for="(img, i) in pdfImages" :key="i" :index="i">-->
          <!--                <img :src="img" alt="..."/>-->
          <!--              </slide>-->
          <!--                <hooper-pagination  slot="hooper-addons" mode="fraction"></hooper-pagination>-->
          <!--            </hooper>-->
          <!--          </div>-->
          <!--          <embed :src="src" class="pdf-viewer__drop__reader"/>-->
        </div>
      </div>
      <v-progress-circular
        v-show="loading"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          color: var(--primary);
          transform: translate(-50%, -50%);
          z-index: 1;
        "
        indeterminate
      />
      <input
        @change="onUploadFile"
        ref="fileInput"
        type="file"
        class="pdf-viewer__file-input"
        data-test="pdfViewer-uploadFile-input"
      />
      <div>
        <v-btn
          v-if="clearable && pdf.images.length"
          @click.stop="clear"
          color="error"
          class="mt-1"
          data-test="pdfViewer-clear-btn"
        >
          {{ $t("clear") }}
        </v-btn>
        <v-btn
          @click="
            () => {
              if (!loading) {
                $refs.fileInput.click();
              }
            }
          "
          v-if="pdf.images.length && canUploadFile"
          color="success"
          class="mt-1 ml-2"
        >
          {{ $t("attachFile") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import "./pdf-viewer.scss";
import { isFileDocument, prepareBase64 } from "@/utils/pureFunctions";
import { RESOURCE_URL } from "../../config";
import {
  Hooper,
  Slide,
  // Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
import "hooper/dist/hooper.css";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const stateRotation = [
  "rotate(0)",
  "rotate(90deg) scale(0.5)",
  "rotate(180deg)",
  "rotate(270deg) scale(0.5)",
];

export default {
  name: "PdfViewer",
  components: {
    Hooper,
    Slide,
    // HooperPagination,
    HooperNavigation,
    CoolLightBox,
  },
  props: {
    contractId: {
      type: String,
    },
    withBtn: {
      type: Boolean,
      default: true,
    },
    canUploadFile: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    offsetBottom: {
      type: Number,
      default: 350,
    },
  },
  data() {
    return {
      RESOURCE_URL: RESOURCE_URL,
      currentRotateStateIndex: 0,
      carouselPage: null,
      coolBoxIndex: null,
      startDraggingFile: false,
      imageData: [],
      loading: false,
      pdf: {
        name: null,
        images: [],
        total: 0,
      },
      currentPage: 0,
    };
  },
  created() {
    if (this.contractId) {
      this.getProductImage();
    }
  },
  watch: {
    contractId() {
      this.getProductImage();
    },
  },
  methods: {
    async getProductImage() {
      try {
        const { data } = await this.$httpmdc.get("/contract-attachments", {
          params: {
            contract_id: this.contractId,
          },
        });
        this.imageData = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    getCurrentSlidePage(e) {
      this.currentPage = e.currentSlide;
    },
    nextPage() {
      this.handleSlide(this.$refs.carousel.currentSlide + 1);
    },
    prevPage() {
      this.handleSlide(this.$refs.carousel.currentSlide - 1);
    },
    rotate() {
      if (stateRotation[this.currentRotateStateIndex + 1]) {
        this.currentRotateStateIndex++;
      } else {
        this.currentRotateStateIndex = 0;
      }
    },
    isFilePdf(file) {
      return file.type.indexOf("pdf") > -1;
    },
    // setSource(src) {
    //   if (src !== this.src) {
    //     this.src = null;
    //     setTimeout(() => {
    //       this.src = src;
    //     });
    //   }
    // },
    onDrop(e) {
      if (e.dataTransfer.files.length && !this.loading) {
        const file = e.dataTransfer.files[0];
        this.setFile(file);
      }
      this.startDraggingFile = false;
    },
    onDragLeave(e) {
      e.preventDefault();
      this.startDraggingFile = false;
    },
    showFile({ images = [], name = null, total = 0 }) {
      this.pdf = {
        images,
        name,
        total,
      };
    },
    async setFile(file) {
      if (file) {
        if (isFileDocument(file)) {
          this.loading = true;
          const formData = new FormData();
          formData.append("file", file);
          try {
            let {
              data: {
                data: { pages },
              },
            } = await this.$http.post(
              "attachment/compression-base64",
              formData
            );
            pages = prepareBase64(pages);
            this.pdf.images = pages;
            this.$emit("upload-file", {
              file,
              name: file.name,
              pages,
            });
          } catch (e) {
            this.setResponseError({ error: e });
          }
        } else {
          this.setErrors({
            text: this.$t("serverErrorMessages.formatFileNotSupported"),
          });
        }
      }
      this.loading = false;
    },
    onUploadFile({ target }) {
      const file = target.files[0];
      this.setFile(file);
      this.$nextTick(() => {
        target.setAttribute("type", "text");
        target.setAttribute("type", "file");
      });
    },
    onDragEnter() {
      this.startDraggingFile = true;
    },
    onDragOver(e) {
      e.preventDefault();
    },
    handleSlide(page) {
      this.$refs.carousel.slideTo(page ? page : this.carouselPage - 1);
    },
    clear() {
      this.pdf = {
        name: null,
        images: [],
        total: 0,
      };
    },
  },
  computed: {
    contentHeight() {
      let height = this.$vuetify.breakpoint.height - this.offsetBottom;
      if (height < 300) height = 300;
      return height;
    },
    rotationPdfViewer() {
      return stateRotation[this.currentRotateStateIndex];
    },
    isPrevDisabled() {
      return this.pdf.images && this.currentPage == 0;
    },
    isNextDisabled() {
      return this.pdf.images && this.currentPage == this.pdf.images.length - 1;
    },
  },
};
</script>
